import { NativeBridge } from "./native-bridge"

export class BridgeAccessService {
    static active = false

    static getAppHeaders = (method, apiRelativeUrl, reqPayload) => {
        return new Promise((resolve, reject) => {
            checkAndGetHeaders(method, apiRelativeUrl, reqPayload, resolve, reject)
        })
    }
}

const checkAndGetHeaders = (method, apiRelativeUrl, reqPayload, resolve, reject) => {
    if (!BridgeAccessService.active) {
        BridgeAccessService.active = true
        NativeBridge.getHeaders(method, apiRelativeUrl, reqPayload).then((value) => {
            BridgeAccessService.active = false
            resolve(value)
        }, error => {
            BridgeAccessService.active = false
            reject(error)
        })
    }
    else {
        setTimeout(() => { checkAndGetHeaders(method, apiRelativeUrl, reqPayload, resolve, reject) }, 0)
    }
}